import React, { useState, useEffect, useContext } from 'react';
// import { Link } from 'react-router-dom';
import api from '../../service/api';
import {
  Paper, Tooltip, IconButton, Button,
  Stack,
  Radio,
  Alert,
  Box
} from '@mui/material';
import ProgressBar from '../progress/progressBar';
import HomeIcon from '@mui/icons-material/Home';
import CheckIcon from '@mui/icons-material/Check';
// import CONSTANT from '../../Constant/Constant';
// import moment from 'moment';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
// import { useHistory } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import TextField from '@mui/material/TextField';
import './style.css';
// import SearchIcon from '@mui/icons-material/Search';
import { DirectionContext } from '../../context/DirectionProvider';
import PotentialMatchConfirm from './PotentialMatchConfirm';

const ViewPotentialMatch = (props) => {
  const id = props?.match?.params?.id
  // const history = useHistory();
  const [progressFlag, setProgressFlag] = useState(true);
  const [potentialMatchConfirmOpen, setPotentialMatchConfirmOpen] = useState(false);
  const [data, setData] = useState(null);
  const direction = useContext(DirectionContext);
  const [selectedProfile, setSelectedProfile] = useState(null)

  const goToHome = () => {
    props.history.push('/');
  }

  const goBack = () => {
    props.history.goBack();
  };

  useEffect(() => {
    fetchData(id)
  }, [id]);

  async function fetchData(id) {
    // if (localStorage.getItem("data")) {
    //   setProgressFlag(false)
    //   return setData(JSON.parse(localStorage.getItem("data")))
    // }
    await api
      .viewPotentialMatchById(id)
      .then(response => {
        setData(response.data)
      })
      .catch(error => {
        console.log("Error in fetch api", error)
      })
      .finally(() => setProgressFlag(false))
  };

  const getSafelyFromEntity = (key) => {
    const val = data?.request_body?.updatedValue?.entity?.[key] ?? null
    if (val && Array.isArray(val) && val[0].value) {
      return val[0].value
    }
    return null
  }

  const getSafelyFromEntityAddress = (key) => {
    if (!data?.request_body?.updatedValue?.entity?.Address || !Array.isArray(data?.request_body?.updatedValue?.entity?.Address)) {
      return null
    }
    const val = data.request_body.updatedValue.entity.Address[0][key] ?? null
    if (val && Array.isArray(val) && val[0].value) {
      return val[0].value
    }
    return null
  }

  const getAllSpecialties = () => {
    /*
    "NewSpecialities": {
        "OtherSpecialty": [
            {
                "value": [
                    "Accident / Trauma Surgery, Sport Traumatology | ATSST | ATSST"
                ]
            }
        ],
        "PrimarySpecialty": [
            {
                "value": "Abdominal Surgery | AS | AS"
            }
        ]
    },
    */
    const obj = data?.request_body?.updatedValue?.entity?.NewSpecialities
    const specialties = []
    if (obj && obj.PrimarySpecialty && Array.isArray(obj.PrimarySpecialty)) {
      specialties.push(obj.PrimarySpecialty[0].value)
    }

    if (obj && obj.OtherSpecialty && Array.isArray(obj.OtherSpecialty)) {
      specialties.push(...obj.OtherSpecialty[0].value[0].split(","))
    }

    return specialties.length ? specialties : []
  }

  const getAllIdentifiers = () => {
    const obj = data?.request_body?.updatedValue?.entity?.NewIdentifiers

    if (!obj || !obj.length) {
      return []
    }
    const items = []
    for (var item of obj) {
      if (item && item.ID && item.ID[0].value && item.Type && item.Type[0].value) {
        items.push({
          type: item.Type[0].value.split("|")[0].trim(),
          value: item.ID[0].value
        })
        // items.push(`${item.Type[0].value}: ${item.ID[0].value}`)
      }
    }
    return items
  }

  // const entity = data?.request_body?.updatedValue?.entity ?? {}
  const eph_profiles = data?.eph_profiles ?? null

  if (eph_profiles && Array.isArray(eph_profiles)) {
    eph_profiles.map(profile => {
      const identifiers = []
      if (profile.attributes.Identifiers) {
        profile.attributes.Identifiers.sort((a, b) => a.label.localeCompare(b.label)).map(item => {
          identifiers.push(item.label)
          return item
        })
      }
      profile.attributes.displayIdentifiers = [{ value: identifiers.join("\r\n") }]

      const specialties = []
      if (profile.attributes.Specialities) {
        profile.attributes.Specialities.sort((a, b) => a.label.localeCompare(b.label)).map(item => {
          specialties.push(item.label)
          return item
        })
      }
      profile.attributes.displaySpecialties = [{ value: specialties.join("\r\n") }]
      return profile
    })
  }

  const displayAttributes = [
    {
      "key": "FirstName",
      "label": "First Name"
    },
    {
      "key": "MiddleName",
      "label": "Middle Name"
    },
    {
      "key": "LastName",
      "label": "Last Name"
    },
    {
      "key": "Title",
      "label": "Title"
    },
    {
      "key": "ClassificationCode",
      "label": "Classification Code"
    },
    {
      "key": "ActiveFlag",
      "label": "Active Flag"
    },
    {
      "key": "EffectiveStartDate",
      "label": "Effective Start Date"
    },
    {
      "key": "EffectiveEndDate",
      "label": "Effective End Date"
    },
    {
      "key": "displayIdentifiers",
      "label": "Identifiers"
    },
    {
      "key": "displaySpecialties",
      "label": "Specialties"
    }
  ]

  let selected_profile_reference_id = 'New!'
  if (data && data.eph_profiles && Array.isArray(data.eph_profiles) && data.selected_profile !== '') {
    const item = data.eph_profiles.find(item => item.uri.indexOf(data.selected_profile))
    if (item) {
      selected_profile_reference_id = item.attributes.HCPReferenceId[0].value
    }
  }

  return (
    <React.Fragment>
      <section className={"container body-height extra-margin-top-less view-potential"}>
        {
          progressFlag
          &&
          <div className="d-flex justify-content-center extra-margin-top">
            <ProgressBar />
          </div>
        }
        {
          !progressFlag &&
          <>
            <Paper square className='mb-2'>
              <Stack direction={'row'} gap={0} justifyContent={'space-between'} alignItems={'center'}>
                <div className="tabdata">
                  <ul className="nav">
                    <li id="track-head"
                      className={`active _wg-exclude`}>
                      Review Multi Match
                    </li>
                  </ul>
                </div>
                <Stack direction={'row'} gap={1}>
                  <Tooltip disableFocusListener title="Back" id="tooltip">
                    <IconButton aria-label="back"
                      className="text-danger float-end"
                      onClick={goBack} color="secondary">
                      <ArrowBackIcon sx={{ transform: direction === 'rtl' ? 'rotate(180deg)' : '' }} />
                    </IconButton>
                  </Tooltip>
                  <IconButton aria-label="home" onClick={goToHome} className=' float-end'
                    color="secondary">
                    <Tooltip disableFocusListener title="Return To Home" id="tooltip">
                      <HomeIcon className="text-danger "
                      />
                    </Tooltip>
                  </IconButton>
                </Stack>
              </Stack>
            </Paper>
            <div className="outlet">

              {/* Show error message if no profiles returned from eph api */}
              {eph_profiles && eph_profiles.errorMessage && <>
                <Alert severity="error">
                  Error fetching matchin profiles details<br />
                  {eph_profiles.errorMessage}
                </Alert>
              </>}

              <div className='hr-at-end'>
                {getSafelyFromEntity('Prefix') &&
                  <div>
                    <b>Prefix: </b>{getSafelyFromEntity('Prefix')}
                  </div>}
                {getSafelyFromEntity('FirstName') &&
                  <div>
                    <b>First Name: </b>{getSafelyFromEntity('FirstName')}
                  </div>}
                {getSafelyFromEntity('MiddleName') &&
                  <div>
                    <b>Middle Name: </b>{getSafelyFromEntity('MiddleName')}
                  </div>}
                {getSafelyFromEntity('LastName') &&
                  <div>
                    <b>Last Name: </b>{getSafelyFromEntity('LastName')}
                  </div>}
                {getSafelyFromEntity('ClassificationCode') &&
                  <div>
                    <b>Classification Code: </b>{getSafelyFromEntity('ClassificationCode')}
                  </div>}
              </div>

              <div className='hr-at-end'>
                {getSafelyFromEntity('Email') &&
                  <div>
                    <b>Email: </b>{getSafelyFromEntity('Email')}
                  </div>}
                {getSafelyFromEntity('Phone') &&
                  <div>
                    <b>Phone: </b>{getSafelyFromEntity('Phone')}
                  </div>}
              </div>

              <div className='hr-at-end'>
                {getSafelyFromEntityAddress('AddressLine1') &&
                  <div>
                    <b>AddressLine1: </b>{getSafelyFromEntityAddress('AddressLine1')}
                  </div>}
                {getSafelyFromEntityAddress('City') &&
                  <div>
                    <b>City: </b>{getSafelyFromEntityAddress('City')}
                  </div>}
                {getSafelyFromEntityAddress('StateProvince') &&
                  <div>
                    <b>State/Province: </b>{getSafelyFromEntityAddress('StateProvince')}
                  </div>}
                {getSafelyFromEntityAddress('Zip') &&
                  <div>
                    <b>Zip: </b>{getSafelyFromEntityAddress('Zip')}
                  </div>}
              </div>

              {getAllSpecialties().length > 0 && <><b>Specialties:</b><br />
                {getAllSpecialties().map((item, index) => <div key={index}>{item}</div>)}
                <hr /></>}

              {getAllIdentifiers().length > 0 && <><b>Identifiers:</b><br />
                {getAllIdentifiers().map((item, index) => <div key={index}>{item.type}: {item.value}</div>)}
                <hr /></>}

              {Array.isArray(eph_profiles) && <TableContainer component={Paper}>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell component="th" className='attributes_label'>Reference ID</TableCell>
                      {eph_profiles.map((profile, index) => <TableCell component="th" key={index} className={{ attributes_label: true, 'selected-profile-td': profile.uri.indexOf(data.selected_profile) !== -1 }}>
                        {profile.attributes.HCPReferenceId[0].value}
                        {/* selected profile then show tick mark here */}
                        {profile.uri.indexOf(data.selected_profile) !== -1 && <CheckIcon color='success' />}
                      </TableCell>)}
                      <TableCell>New Profile</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {displayAttributes.map((attr, index) => (
                      <TableRow key={index}>
                        <TableCell className={'attributes_label'}>
                          {attr.label}
                        </TableCell>
                        {eph_profiles.map((profile, index) => <TableCell
                          key={index}
                          className={{ 'attributes_value': true, 'selected-profile-td': profile.uri.indexOf(data.selected_profile) !== -1 }}>
                          {profile.attributes[attr.key] ? profile.attributes[attr.key][0].value : ' - '}
                        </TableCell>)}
                        <TableCell></TableCell>
                      </TableRow>
                    ))}

                    {data && data.review_status !== "Completed" && <TableRow>
                      <TableCell className={'attributes_label'}>
                        Select Profile
                      </TableCell>
                      {eph_profiles.map((profile, index) => <TableCell key={index}
                        className={{ 'attributes_value': true }}>
                        <label htmlFor={`selected-profile-${profile.uri}`}>{profile.attributes.HCPReferenceId[0].value}</label>
                        <Radio id={`selected-profile-${profile.uri}`} color='success' name='selected_profile' value={profile.uri} checked={selectedProfile === profile.uri} onClick={() => setSelectedProfile(profile.uri)} />
                      </TableCell>)}

                      {/* Consider as new option. in Table it self */}
                      <TableCell className={'attributes_value'}>
                        <label htmlFor='selected-profile-none'>Consider as New HCP</label>
                        <Radio id='selected-profile-none' color='success' name='selected_profile' value={''} checked={selectedProfile === ''} onClick={() => setSelectedProfile('')} />
                      </TableCell>
                    </TableRow>}
                  </TableBody>
                </Table>
              </TableContainer>}

              {/* <div>
                <label htmlFor='selected-profile-none'>Consider as New HCP</label> <Radio id='selected-profile-none' color='secondary' name='selected_profile' value={''} checked={selectedProfile === ''} onClick={() => setSelectedProfile('')} />
              </div> */}

              {data && data.review_status == "Completed" && <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 2 }}>
                <Alert severity="success">
                  Review completed on {data.updated_at} by {data.updated_by}<br />
                  Profile Selected: {selected_profile_reference_id !== '' ? selected_profile_reference_id : 'NEW'}<br />
                  Review Comment: {data.review_comment}
                </Alert>
              </Box>}


              {data && data.review_status !== "Completed" && <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 2 }}>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={selectedProfile === null}
                  onClick={() => {
                    setPotentialMatchConfirmOpen(true)
                  }}>Submit DCR</Button>
              </Box>}

              {/* <pre>{JSON.stringify(eph_profiles, null, 4)}</pre> */}

            </div>
          </>
        }
      </section>

      <PotentialMatchConfirm
        data={data}
        selectedProfile={selectedProfile}
        profileInfo={Array.isArray(data?.eph_profiles) ? data.eph_profiles.find(item => item.uri.indexOf(selectedProfile) !== -1) : null}
        open={potentialMatchConfirmOpen}
        onClose={() => {
          setPotentialMatchConfirmOpen(false)
          // refresh api response
          fetchData(id)
        }} />

    </React.Fragment>
  );
};



export default ViewPotentialMatch;
